import { Inject, Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PurchaseService } from '../../../services/purchase.service';
import { PriceHistoryService } from '../../../services/price-history.service';
import { MasterItemsService } from '../../../services/master-items.service';
import { Methods } from '../../../shared/methods';
import { DinamicData, Cell } from '../../../models/dinamic-data';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare var $: any;

@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.css']
})
export class BuscadorComponent implements OnInit {

  public mtds: Methods = new Methods();

  public loading = false;
  public saving = false;
  public edit = false;
  public data2: any;
  public lineItems = [];
  public conditions = [];

 public show_no_data = false;

  public filteritem;

  public dataInFo: DinamicData = new DinamicData(
    [
      'ID',
      'Item',
      'Mfgr',
      'Description',
      'Category',
      'Category 2',
      'Category 3',
      'Category 4',
      'Weight',
      ''
    ]
  );

 
  constructor(
    public dialogRef: MatDialogRef<BuscadorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _purchaseService: PurchaseService,
    private _pricehistoryService: PriceHistoryService,
    private _masterItemsService: MasterItemsService
  ) {
    console.log(data);
    this.filteritem = data.search
    this.getData();
  
  }

  ngOnInit() {
   


    $("#changcostmodal").on("hidden.bs.modal",  () => {
      console.log('Se detecto cierre de modal');
    
    });
  }



getData() {
    let me = this;
    console.log(this.filteritem);
    this.loading = true;
    this.show_no_data = false

    this.dataInFo.rows = [];
 
    this._masterItemsService.search(this.filteritem).subscribe(
      (r) => {
        console.log("response item =>", r);

        if(r.data.length == 0){
          this.show_no_data = true;
        }
        r.data.map( s => {
           this.dataInFo.rows.push(
          [
            new Cell(s.id),
            new Cell(s.partNumber),
            new Cell(s.mfgr != null && s.mfgr.name ? s.mfgr.name : ''),
            new Cell(s.descripcion),
            new Cell(s.inventoryCategory != null && s.inventoryCategory.name ? s.inventoryCategory.name : ''),
            new Cell(s.inventoryCategory2 != null && s.inventoryCategory2.name ? s.inventoryCategory2.name : ''),
            new Cell(s.inventoryCategory3 != null && s.inventoryCategory3.name ? s.inventoryCategory3.name : ''),
            new Cell(s.inventoryCategory4 != null && s.inventoryCategory4.name ? s.inventoryCategory4.name : ''),
            new Cell(s.weight),
            
            new Cell( [{ icon: 'remove_red_eye', action: 'Show', color: 'primary', value: s }], {type: 'actions'})
          ]
        )
        })
       

      
        this.loading = false;
      }
    );
  }

  actions(event) {
    console.log("action event =>", event);

    this.dialogRef.close(event);
    
  }

  close() {
    this.dialogRef.close();
  }

}
